/* ==========================================================================
   Publishes the header's own state onto <html> as .header-off.

   The header hides itself on the way down by adding .header--hidden to
   itself. Anything else that is stuck to the top of the screen — the
   collection toolbar today, anything sticky tomorrow — needs to know, or it
   keeps its distance from a header that is no longer there and leaves a strip
   of the page scrolling through the gap.

   Written as a watcher rather than a second scroll listener on purpose: one
   place decides when the header hides (theme.js), and this only repeats that
   decision one level up the tree. No duplicated thresholds to drift apart.
   ========================================================================== */
(function () {
  'use strict';

  /* The rule lives here, next to the state that switches it on, because it is
     meaningless without it: the header only hides through JavaScript, so a
     stylesheet rule keyed on .header-off could never fire on its own. One file
     to read, one file to delete if the behaviour is ever dropped. */
  function styleOnce() {
    if (document.getElementById('vg-header-state-css')) return;
    var st = document.createElement('style');
    st.id = 'vg-header-state-css';
    st.textContent =
      '.toolbar{transition:top 300ms var(--vg-ease,ease)}' +
      '.header-off .toolbar{top:0}' +
      '@media (prefers-reduced-motion:reduce){.toolbar{transition:none}}';
    document.head.appendChild(st);
  }

  function attach() {
    var header = document.querySelector('vg-header, .header');
    if (!header || header.dataset.vgState) return;
    header.dataset.vgState = '1';

    var sync = function () {
      document.documentElement.classList.toggle(
        'header-off',
        header.classList.contains('header--hidden')
      );
    };

    new MutationObserver(sync).observe(header, {
      attributes: true,
      attributeFilter: ['class']
    });
    styleOnce();
    sync();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attach);
  } else {
    attach();
  }
  // The theme editor re-renders the header section in place.
  document.addEventListener('shopify:section:load', attach);
})();
